import { TYPE } from './type.js';
import { initialState } from './initial-state.js';

const AddressReducer = (state = initialState, action) => {
    switch (action.type) {
        case TYPE.ADDRESS_LIST:
            return {
                ...state,
                addressList: action.payload
            }
        case TYPE.SET_LOADER:
            return {
                ...state,
                loader: action.payload
            }
        default:
            return state;
    }
}

export default AddressReducer;